import React from "react";
import logo from "./logo.png";
import CallTwoToneIcon from "@mui/icons-material/CallTwoTone";
import SignIn from "../../../components/userAuth/SignIn";
function Navbar() {
  return (
    <div>
      <div className="flex justify-between w-screen font-nunito py-2 lg:px-28 px-10 bg-white shadow-md  ">
        <a href="/">
          <div className="">
            <img src={logo} className="w-3/5 p-1" alt="logo" />
          </div>
        </a>

        <div className="flex gap-4 m-2 ">
          {/* Call us Button */}
          <div className="flex border-2 items-center gap-2 text-base px-2 py-1 sm:scale-y-90 bg-gradient-to-tr from-blue-500 to-green-500 rounded-lg text-white hover:bg-gradient-to-tr hover:to-blue-500 hover:from-green-500 min-w-fit">
            <a
              href="tel:9930404202"
              className="text-inherit no-underline bg-inherit"
            >
              <CallTwoToneIcon
                fontSize="small"
                className="scale-75 sm:scale-90  "
              />
              <p className="m-0 p-0 inline">CallUs</p>
            </a>
          </div>
          <SignIn />
        </div>
      </div>
      <div className="h-1 bg-gradient-to-r from-blue-500 to-green-500 shadow-md w-screen"></div>
    </div>
  );
}

export default Navbar;
